
import React, { useState, useEffect } from "react";
import axios from 'axios';
import { RouterProvider } from "react-router-dom";
import { router } from "./routes";
import { MsalProvider } from "@azure/msal-react";
import { AuthProvider } from "./services/AuthContext";
import { initializeMsalInstance, getMsalInstance } from "./authConfig";

const LoadConfig = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    // Fetch the config on app load
    axios.get('/config.json')
      .then((response) => {
        const configData = response.data;
        window.appconfig = { ...response.data };
        setConfig(configData);
        initializeMsalInstance()
      })
      .catch((error) => {
        console.error("Error loading config:", error);
      });

  }, []);


  if (config){
    const msalInstance =  getMsalInstance()
    return <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </MsalProvider>
    }
  return null; // This component does not render anything
};

export default LoadConfig;